export const DEFAULT_CRON = '0 0 * * * *';

export const DEFAULT_AUTO_HOUR = 1;

export const DAY_HOURS = 24;
export const HALF_DAY_HOURS = DAY_HOURS / 2;
export const HOUR_MINUTES = 60;
